import lodash from 'lodash';

export const toInteger = (num: string) => {
	return parseInt(num, 10);
};

export const getPrizeDistributions = (prizeDistributions, maxWinners) => {
	if (lodash.isEmpty(prizeDistributions)) return {};
	const prizeDistriution = Object.entries(prizeDistributions[maxWinners]);
	const prizeGroups = [];
	for (let i = 0; i < prizeDistriution.length; i += 1) {
		prizeGroups.push({ rank: toInteger(prizeDistriution[i][0]), prize: toInteger(prizeDistriution[i][1]) });
	}
	return { prizeGroups, totalDistributions: prizeGroups.length, totalWinners: toInteger(maxWinners) };
};

export const splitStringAndConvertToNumber = (inputString: string) => {
	const stringArray = inputString.split(',');
	const numberArray = stringArray.map((value) => {
		return toInteger(value);
	});
	return numberArray;
};

export function parseStringToBoolean(stringValue: string) {
	const lowerCaseValue = stringValue.toLowerCase();
	return lowerCaseValue === 'true';
}

export const prepareCreateSchema = (obj) => {
	let schema: any = {};
	schema.entryFee = toInteger(obj.ENTRY_FEE);
	schema.gameName = 'ludo';
	schema.isActive = true;
	schema.instruction = obj.INSTRUCTION;
	schema.isQuickTournament = parseStringToBoolean(obj.isQuickTournament);
	schema.isSpecial = parseStringToBoolean(obj.IS_SPECIAL);
	schema.maxWinners = toInteger(obj.MAX_NO_WINNERS);
	schema.numberOfRounds = toInteger(obj.NUMBER_OF_ROUNDS);
	schema.playersPerTable = toInteger(obj.PLAYERS_PER_TABLE);
	schema.segmentsList = obj.SEGMENTS_LIST;
	schema.winnersPerTable = toInteger(obj.WINNERS_PER_TABLE);
	schema.userLevelsSupported = splitStringAndConvertToNumber(obj.LEVELS);
	schema.tournamentStartTime = obj.TOURNAMENT_START_TIME;
	schema.tournamentRegistrationStartTime = obj.REGISTRATION_START_TIME;
	schema.tournamentDisplayTime = obj.DISPLAY_START_TIME;
	schema.tournamentComingSoonTime = !lodash.isEmpty(obj.DISPLAY_COMING_SOON_TIME) ? obj.DISPLAY_COMING_SOON_TIME : null;
	schema.timeLimitInSecs = !lodash.isEmpty(obj.timeLimitInSecs) ? toInteger(obj.timeLimitInSecs) : null;
	schema.stt = !lodash.isEmpty(obj.stt) ? toInteger(obj.stt) : null;
	schema.rakebackPoints = !lodash.isEmpty(obj.RAKEBACK_POINTS) ? parseFloat(obj.RAKEBACK_POINTS) : undefined;
	schema.enableMLMatchMaking = parseStringToBoolean(obj.ENABLE_MATCH_MAKING);
	const { prizeGroups, totalDistributions, totalWinners } = getPrizeDistributions(
		JSON.parse(obj.PRIZE_DISTRIBUTION),
		obj.MAX_NO_WINNERS
	);
	schema = { ...schema, prizeGroups, totalDistributions, totalWinners };
	return schema;
};
